// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".users-table .users-table__name--disabled[data-v-cf3e81ae]{opacity:.5}@media(min-width:768px){.users-table .user-crown[data-v-cf3e81ae]{display:none}}@media(min-width:1024px){.users-table .date-sm[data-v-cf3e81ae]{display:none}}", ""]);
// Exports
module.exports = exports;
